import React, { useEffect, useState, useCallback } from 'react'
import './MediaThumbnail.scss'
import { RiCheckFill, RiPencilFill } from 'react-icons/ri'
import { TiDelete } from 'react-icons/ti'
import TextField from '@mui/material/TextField'
import Tooltip from '@mui/material/Tooltip';
import { FaTimes } from 'react-icons/fa'
import RenderThumbnailPicture from "./RenderThumbnailPicture "

const MediaThumbnail = React.memo(({
  type,
  media,
  index,
  subType,
  onUpdate,
  removeMediaEvent,
  removeOnlineVideo,
  duration,
  isDiscardedMedia,
  disableHandleClick = false
}) => {
  const [showCaption, setShowCaption] = useState(true)
  const [caption, setCaption] = useState('')
  const [url, setUrl] = useState(() => {
    if (type !== 'image') return ''
    if (media?.url) return media.url
    if (media?.object) return window.URL.createObjectURL(media.object)
    return ''
  })

  useEffect(() => {
    discardCaption()
  }, [isDiscardedMedia])

  useEffect(() => {
    // Create the video thumbnail
    if (type === 'video') {
      const video = document.getElementById('video' + index)
      const canvas = document.createElement('canvas')
      canvas.width = 640
      canvas.height = 480
      if (video) {
        video.style.display = "none"
        video.currentTime = 5
      }
    }
    if (media.caption) {
      setCaption(media.caption)
    }
    if (type === 'image') {
      setUrl(media.url || window.URL.createObjectURL(media.object))
    }
  }, [index, media, type, subType]);

  const saveCaption = () => {
    if (!disableHandleClick) {
      media.caption = caption
      onUpdate(media)
      setShowCaption(true)
    }
  }

  const discardCaption = () => {
    if (!disableHandleClick) {
      setCaption(media.caption)
      setShowCaption(true)
    }

  }

  const handleCaptionChange = (e) => {
    setCaption(e.currentTarget.value);
  };

  const fixedUrl = useCallback(() => {
    if(media.url.startsWith("http")) {
      return media.url
    } else {
      return `https://${media.url}`
    }
  }, [media.url]
)

const toHHMMSS = (secs) => {
  var sec_num = parseInt(secs, 10)
  var hours   = Math.floor(sec_num / 3600)
  var minutes = Math.floor(sec_num / 60) % 60
  var seconds = sec_num % 60

  let duration = [hours,minutes,seconds]
    .map(v => v < 10 ? "0" + v : v)
    .filter((v,i) => v !== "00" || i > 0)
    .join(":")

  return (<span className="media-item">{duration}</span>)
}

const renderOnlineThumbnail = type => {
  switch (type) {
    case 0:
      return (
        <RenderThumbnailPicture
          avifImage="/images/youtube.avif"
          webpImage="/images/youtube.webp"
          pngImage="/images/youtube.png"
        />
      )
    case 1:
      return (
        <RenderThumbnailPicture
          avifImage="/images/vimeo.avif"
          webpImage="/images/vimeo.webp"
          pngImage="/images/vimeo.png"
        />
      )
    case 2:
      return (
        <RenderThumbnailPicture
          avifImage="/images/facebook.avif"
          webpImage="/images/facebook.webp"
          pngImage="/images/facebook.png"
        />
      )
    case 3:
      return (
        <RenderThumbnailPicture
          avifImage="/images/daily.avif"
          webpImage="/images/daily.webp"
          pngImage="/images/daily.png"
        />
      )
    default:
      return ""
  }
}

  return (
    <div className="media-thumbnail">
      {type === 'image' ? (url ? <img src={url} alt="" /> : null) : (
        <>
          {type === "online" ? renderOnlineThumbnail(media.provider) : (
            <RenderThumbnailPicture
              avifImage="/images/videoplayer.avif"
              webpImage="/images/videoplayer.webp"
              pngImage="/images/videoplayer.png"
            />
          )}
        </>
      )}
      <div className="media-info">
        <div className="caption-container">
          {showCaption ? (
            <div className="caption-container-display">
              <Tooltip title={caption} placement="top" arrow>
                <span className="file-name" data-title={caption}>{caption}</span>
              </Tooltip>
              <RiPencilFill className="edit-icon" onClick={!disableHandleClick ? () => setShowCaption(false) : ()=>{}} />
            </div>
          ) : (
            <div className="caption-input-container">
              <TextField
                id="caption"
                name="caption"
                variant="outlined"
                value={caption}
                inputProps={{ maxLength: 40 }}
                onChange={handleCaptionChange} />
              <div className="caption-controls-container">
                <RiCheckFill className="save-caption" onClick={() => saveCaption()} />
                <FaTimes className="discard-caption" onClick={() => discardCaption()} />
              </div>
            </div>
          )
          }
        </div>
        <div className="info-container">
          <Tooltip title={media.originalName || media.FileName} placement="bottom" arrow>
            <span className="media-item">
              {type === "online" ? "" : (media.originalName || media.FileName)}
            </span>
          </Tooltip>
          <span className="media-item">{media.type.charAt(0).toUpperCase() + media.type.slice(1)}: {media.size}</span>
          {
            media.type === 'video' && media.secondsDuration ?
            toHHMMSS(media.secondsDuration)
            :<></>
          }
          {type === "online"  ? (
            <a className="video-url" rel="noopener noreferrer" target="_blank" href={media.url && fixedUrl()}>{media.url && fixedUrl()}</a>
          ) : null}
        </div>
      </div>
      { !disableHandleClick &&
        <TiDelete
          className="delete-icon"
          onClick={type !== undefined && type === "online" ? () => removeOnlineVideo(media) : () => removeMediaEvent(media, type)}
        />
      }
    </div>
  )
})

export default MediaThumbnail;
